// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// Libraries
import 'bootstrap/dist/css/bootstrap.css'
import './assets/sass/material-dashboard.scss'
import 'es6-promise/auto'
import Chartist from 'chartist'
import CoreComponents from '@/core/components'
import NotificationPlugin from '@/core/components/mdNotifications/install'
import vClickOutside from 'v-click-outside'
// import { createProvider } from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'

import VueApollo from 'vue-apollo'

import * as firebase from 'firebase'

import VModal from 'vue-js-modal'

import moment from 'moment-timezone'
import VueMoment from 'vue-moment'
import { BPopover, PopoverPlugin } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)
Vue.use(PopoverPlugin)

Vue.use(VueMoment, { moment })

// Vue.use(VModal, { dialog: true })
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dialog: true })

Vue.config.productionTip = false

const httpLink = new HttpLink({
  uri: 'https://obee.engmadev.com/v1/graphql'
})

const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = store.getters.token
  // Return the headers to the context so httpLink can read them
  // console.log(token)
  let authToken = token ? { authorization: `Bearer ${token}` } : {}
  let autHeaders = {
    ...headers,
    ...authToken
  }
  // console.log(autHeaders)
  return {
    headers: autHeaders
  }
})

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true
})

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

// global library setup
Object.defineProperty(Vue.prototype, '$Chartist', {
  get() {
    return this.$root.Chartist
  }
})

// Use Core Components
Vue.use(CoreComponents)
Vue.use(NotificationPlugin)
Vue.use(vClickOutside)

/**
 * Firebase config
 */

var firebaseConfig = {
  apiKey: 'AIzaSyCVNdlJ9UrWri2NgV_pMsngTy80tbYlMY8',
  authDomain: 'obee-demo.firebaseapp.com',
  databaseURL: 'https://obee-demo.firebaseio.com',
  projectId: 'obee-demo',
  storageBucket: 'obee-demo.appspot.com',
  messagingSenderId: '47759886820',
  appId: '1:47759886820:web:6a5d5205c447d18eba1ff1',
  measurementId: 'G-NSKPY3P8VF'
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)
firebase.analytics()
firebase.auth().onAuthStateChanged(function (user) {
  // console.log(user)
  if (user && user.emailVerified) {
    store.commit('setUser', user.uid)
    store.commit('setIsLoggedIn', true)
    store.commit('setIsHomePage', false)
  } else {
    // User is signed out.
    // ...
    console.log('User logout')
    store.commit('setUser', null)
    store.commit('setIsLoggedIn', false)
    store.commit('setIsHomePage', false)
    store.commit('setToken', null)
  }
})

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = await firebase.getCurrentUser()
  let token = store.getters.token
  if (currentUser && token == null) {
    token = await currentUser.getIdToken(true)
    // console.log('Required token', token)
    store.commit('setToken', token)
  }
  const loggedIn = to.matched.some(y => y.meta.loggedIn)
  const isTeacher = to.matched.some(z => z.meta.isTeacher)
  // const isAdmin = to.matched.some(a => a.meta.isAdmin)
  // console.log('beforeEach | loggedIn | requiresAuth | isHomePage | isTeacher: ', from, to, currentUser, loggedIn, requiresAuth, store.getters.isHomePage, isTeacher)
  if (to.name === 'body' || to.name === 'page_lesson' || to.name === 'page_lesson_detail' || to.name === 'page_video' || to.name === 'page_video_detail' || to.name === 'page_public' || to.name === 'page_public_detail') {
    store.commit('setIsHomePage', true)
  }
  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    if (currentUser.emailVerified) {
      // console.log('Required Auth')
      // console.log(store.getters.fullname, isTeacher, isAdmin)
      if (isTeacher && store.getters.fullname !== undefined && store.getters.fullname !== null && store.getters.fullname.type_user !== 2) {
        next('/account')
      } else next()
    } else {
      next('/login')
    }
  } else {
    // console.log(requiresAuth, currentUser)
    if (loggedIn && store.getters.isLoggedIn) {
      // console.log('Logged In')
      next('/account')
    } else {
      next()
    }
  }
})

require('froala-editor/js/froala_editor.pkgd.min.js')
// Import third party plugins
// import 'froala-editor/js/third_party/embedly.min'
// import 'froala-editor/js/third_party/font_awesome.min'
// import 'froala-editor/js/third_party/spell_checker.min'
// import 'froala-editor/js/third_party/image_tui.min'

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
Vue.config.productionTip = false
import 'froala-editor/js/plugins.pkgd.min.js'
// import '@wiris/mathtype-froala3/wiris.js'

import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime)

import VueI18n from 'vue-i18n'
import vnMessage from '../src/lang/vn.json'
import enMessage from '../src/lang/en.json'

import VueMobileDetection from 'vue-mobile-detection'
Vue.use(VueMobileDetection)

Vue.use(VueI18n)

const messages = {
  vn: vnMessage,
  en: enMessage
}
const i18n = new VueI18n({
  locale: 'vn', // set locale
  messages,
  fallbackLocale: 'vn'
})

import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// Init plugin
Vue.use(Loading)

require('vue-social-sharing/dist/vue-social-sharing.js')
import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing)

import Select2 from 'v-select2-component'
Vue.component('Select2', Select2)

import Meta from 'vue-meta'
Vue.use(Meta, {
  refreshOnceOnNavigation: true
})

import {mycontroller} from './components/Model/mycontroller'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  apolloProvider,
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
  data: {
    Chartist
  }
})
Vue.prototype.$mycontroller = mycontroller



// WEBPACK FOOTER //
// ./src/main.js